/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import { xbkVersion } from '../../actions/download';
import Download from './Download';

const title = '有道精品课-APP下载';

async function action({ store }) {
  await store.dispatch(xbkVersion());

  return {
    chunks: ['download'],
    title,
    keywords: '有道精品课,有道精品课下载,APP下载,iPhone下载,Android下载,客户端下载,小班课PC端下载',
    description: '有道精品课APP下载，包括 iPhone、Android、客户端、小班课PC端版本。有道精品课是网易旗下的知名教育培训品牌，覆盖小学、初中、高中、升学、兴趣素养、围棋、象棋、大学、兴趣技能、小语种、托福雅思、英语口语、考证考级、职业培训技能等全面课程。',
    component: <Download />,
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/download/index.js